import { Typography } from '@/design-system/Atoms';
import { LinkArrowButton } from '@/design-system/Atoms/Button/LinkButton';

interface FeatureCardContentProps {
    title: string;
    description: string;
    link: string;
}

const FeatureCardContent = ({ title, description, link }: FeatureCardContentProps) => (
    <>
        <Typography variant="sectionHeading" as="h2" className="mb-3">
            {title}
        </Typography>
        <Typography variant="sectionDescriptionSmall" className="mb-4 text-gray-700">
            {description}
        </Typography>

        <LinkArrowButton href={link} label="Learn More" />

    </>
);

export default FeatureCardContent;
